import React from "react";
import cn from "classnames";

export interface IOpeningHours {
    currentStatus?: string;
    currentTimeStatus?: string;
    reasonText?: string;
    reasonPageUrl?: string;
    reasonLabel?: string;
    openingHoursLabel?: string;
    openingHoursUrl?: string;
    className?: string;
    hideReason?: boolean;
}

export const OpeningHours = ({
    currentStatus,
    currentTimeStatus,
    reasonText,
    reasonPageUrl,
    reasonLabel,
    openingHoursLabel,
    openingHoursUrl,
    className,
    hideReason = false,
}: IOpeningHours) => {
    return (
        <div className={cn("OpeningHours", className)}>
            <span className="OpeningHours__status">
                <strong>{currentStatus}</strong>
                <span>{currentTimeStatus}</span>
            </span>
            {reasonText && !reasonPageUrl && (
                <span className="OpeningHours__reason">
                    {reasonLabel && reasonLabel} {reasonText}
                </span>
            )}
            {reasonText && reasonPageUrl && !hideReason && (
                <span className="OpeningHours__reason">
                    {reasonLabel && reasonLabel}{" "}
                    <a className="OpeningHours__reason-link" href={reasonPageUrl}>
                        {reasonText}
                    </a>
                </span>
            )}
            {openingHoursLabel && openingHoursUrl && (
                <span className="OpeningHours__hoursLink">
                    <a href={openingHoursUrl}>{openingHoursLabel}</a>
                </span>
            )}
        </div>
    );
};
